import React from "react";

const Footer = () => {
  return <div className="footer">Kalvin Yao 2024</div>;
};

export default Footer;
